import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable, retry, switchMap, takeWhile, timer } from 'rxjs';
import { environment } from '../../../environments/environment';
import { SessionService } from '../../Util/Session/session.service';

export interface TaxStartRequest {
  empCode?: string;
  financialYear: string;
  branchID: number | null;
  clientID: number | null;
  siteID: number | null;
  empType: string;
  empServiceTypeID: number;
  isFilterBasedonGross: boolean;
  filterGrossValues: number;
  initiatedBy?: string;
}

export interface EmployeeProcessedRecord {
  detailId?: number;
  DetailID?: number;
  employeeId: number;
  empCode?: string;
  employeeName: string;
  status: string;
  errorMessage?: string;
  processedAt: string;
}

export interface TaxBatchJob {
  id: string;
  status: 'QUEUED' | 'RUNNING' | 'COMPLETED' | 'FAILED' | 'CANCELLED';
  totalEmployees: number;
  processedCount: number;
  pendingCount: number;
  successCount: number;
  failedCount: number;
  lastHeartbeat?: string;
  processedList: EmployeeProcessedRecord[];
}

@Injectable({
  providedIn: 'root'
})
export class IncometaxService {

  constructor(
    private http: HttpClient,
    private session: SessionService,
  ) {
    try {
      environment.API_URL = this.session.GetUserDetails().ApiUrl;
    } catch (e) { }
  }

  TaxCategoryMasterInsertUpdate(Detail: any = {}) {
    return this.http.post<any>(environment.API_URL + `TaxCategoryMasterInsert/Update`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  TaxCategoryMasterSelectLoad(Detail: any = {}) {
    return this.http.post<any>(environment.API_URL + `TaxCategoryMasterSelect/Load`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  TaxSlabMasterInsertUpdate(Detail: any = {}) {
    return this.http.post<any>(environment.API_URL + `TaxSlabMasterInsert/Update`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  TaxSlabMasterSelectLoad(Detail: any = {}) {
    return this.http.post<any>(environment.API_URL + `TaxSlabMasterSelect/Load`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_TaxSectionFYMaster_InsertUpdate(Detail: any = {}) {
    return this.http.post<any>(environment.API_URL + `ESS_TaxSectionFYMaster_Insert/Update`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_TaxSectionFYMasterSelect(Detail: any = {}) {
    return this.http.post<any>(environment.API_URL + `ESS_TaxSectionFYMaster/Select`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  //need to remove
  TaxSectionMasterSelectLoad(Detail: any = {}) {
    return this.http.post<any>(environment.API_URL + `TaxSectionMasterSelect/Load`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_TaxSubSectionFYMaster_InsertUpdate(Detail: any = {}) {
    return this.http.post<any>(environment.API_URL + `ESS_TaxSubSectionFYMaster_Insert/Update`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  TaxSectionDetail_SelectLoad(Detail: any = {}) {
    return this.http.post<any>(environment.API_URL + `TaxSectionDetail_Select/Load`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  TaxPreviousEmploymentDetailsLoad(Detail: any = {}) {
    return this.http.post<any>(environment.API_URL + `TaxPreviousEmploymentDetails/Load`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  TaxPreviousEmploymentDetailsInsertUpdate(Detail: any = {}) {
    return this.http.post<any>(environment.API_URL + `TaxPreviousEmploymentDetailsInsert/Update`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_EmpTaxDeclaration_InsertUpdate(Detail: any = {}) {
    return this.http.post<any>(environment.API_URL + `ESS_EmpTaxDeclaration_Insert/Update`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_EmpTaxDeclarationSelect(Detail: any = {}) {
    return this.http.post<any>(environment.API_URL + `ESS_EmpTaxDeclaration/Select`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_TaxDeclarationUpdateAtApproval(Detail: any = {}) {
    return this.http.post<any>(environment.API_URL + `ESS_TaxDeclarationUpdate/AtApproval`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_EmpTaxInvestmentSelect(Detail: any = {}) {
    return this.http.post<any>(environment.API_URL + `ESS_EmpTaxInvestment/Select`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }


  ESS_EmpTaxInvestment_InsertUpdate(Detail: any = {}) {
    return this.http.post<any>(environment.API_URL + `ESS_EmpTaxInvestment_Insert/Update`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_TaxInvestmentUpdateAtApproval(Detail: any = {}) {
    return this.http.post<any>(environment.API_URL + `ESS_TaxInvestmentUpdate/AtApproval`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_TaxSubSectionMasterSelect(Detail: any = {}) {
    return this.http.post<any>(environment.API_URL + `ESS_TaxSubSectionMaster/Select`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_IncomeTaxCompareBACK(Detail: any = {}) {
    return this.http.post<any>(environment.API_URL + `ESS_IncomeTaxCompare/BACK`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_IncomeTaxCompare_FRONT(Detail: any = {}) {
    return this.http.post<any>(environment.API_URL + `ESS_IncomeTax/Compare_FRONT`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_IncomeTaxSummaryDetails_InsertUpdate(Detail: any = {}) {
    return this.http.post<any>(environment.API_URL + `ESS_IncomeTaxSummaryDetails_Insert/Update`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_IncomeTaxSummaryDetailsSelect(Detail: any = {}) {
    return this.http.post<any>(environment.API_URL + `ESS_IncomeTaxSummaryDetails/Select`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_TaxFinancialYearSelect(Detail: any = {}) {
    return this.http.post<any>(environment.API_URL + `ESS_TaxFinancialYear/Select`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_TaxFinancialYear_InsertUpdate(Detail: any = {}) {
    return this.http.post<any>(environment.API_URL + `ESS_TaxFinancialYear_Insert/Update`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  GenerateTDSReport(Detail: any = {}) {
    return this.http.post<any>(environment.API_URL + `GenerateTDS/Report`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  GetIncomeTaxReport(Detail: any = {}) {
    return this.http.post<any>(environment.API_URL + `ESS_GetIncomeTaxReport/Get`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  startJob(request: TaxStartRequest): Observable<{ status: string; jobId: string; totalEmployees: number }> {
    request = this.session.SetClass(request);
    return this.http.post<{ status: string; jobId: string; totalEmployees: number }>(
      `${this.API_URL}/process/start`,
      request
    );
  }

  cancelJob(jobId: string): Observable<any> {
    return this.http.post(`${this.API_URL}/jobs/cancel`, this.session.SetClass({ JobGUID: jobId }));
  }

  // pollJobStatus$(jobId: string): Observable<{ job: TaxBatchJob }> {
  //   return timer(0, 2000).pipe(
  //     // 1. Send HTTP request every 2 seconds
  //     switchMap(() => this.http.get<{ job: TaxBatchJob }>(`${this.API_URL}/jobs/${jobId}`)),

  //     // 2. Automatically stop when status is COMPLETED, FAILED, or CANCELLED
  //     takeWhile(
  //       (res) =>
  //         res.job.status !== 'COMPLETED' &&
  //         res.job.status !== 'FAILED' &&
  //         res.job.status !== 'CANCELLED',
  //       true
  //     ),

  //     // 3. RETRY LOGIC:
  //     // - If 1 call fails, wait 2000ms and try again
  //     // - If it succeeds, reset failure counter back to 0!
  //     // - Only if 5 CONSECUTIVE calls fail, throw error to component!
  //     retry({
  //       count: 5,
  //       delay: 2000,
  //       resetOnSuccess: true
  //     })
  //   );
  // }



  API_URL = environment.API_URL + 'api/tax';
  private readonly STORAGE_JOB_KEY = 'active_tax_job_id';

  // pollJobStatus$(jobId: string): Observable<{ job: TaxBatchJob; processedEmployees: any[] }> {
  //   const payload: any = { ...this.session.SetClass({}), JobGUID: jobId };
  //   return timer(0, 5000).pipe(switchMap(() =>
  //     this.http.post<{ job: TaxBatchJob; processedEmployees: any[] }>(`${this.API_URL}/jobs/status`, payload)),
  //     takeWhile((res: any) => res.job.Status !== 'COMPLETED' && res.job.Status !== 'FAILED' && res.job.Status !== 'CANCELLED', true),
  //     retry({ count: 5, delay: 30000, resetOnSuccess: true }));
  // }

  pollJobStatus$(jobId: string): Observable<{ job: TaxBatchJob; processedEmployees: any[] }> {
    const payload: any = {
      ...this.session.SetClass({}),
      JobGUID: jobId
    };

    return this.http.post<{ job: TaxBatchJob; processedEmployees: any[] }>(
      `${this.API_URL}/jobs/status`,
      payload
    );
  }

  // Check if a job is currently running on the server
  checkRunningJob(): Observable<{ hasActiveJob: boolean; jobId: string | null }> {
    return this.http.post<{ hasActiveJob: boolean; jobId: string | null }>(`${this.API_URL}/current-running`, this.session.SetClass({}));
  }

  getAllBatches(): Observable<{ batches: any[] }> { return this.http.post<{ batches: any[] }>(`${this.API_URL}/batches/list`, this.session.SetClass({})); }   /**    * 6. Get Paginated Audit Logs for a Batch (POST)    */


  getBatchLogs(jobId: string, page: number = 1, pageSize: number = 50, FilterStatus?: string, searchText?: string): Observable<{ logs: any[]; totalCount: number }> {
    const payload: any = { ...this.session.SetClass({}), JobGUID: jobId, Page: page, PageSize: pageSize, FilterStatus: FilterStatus || undefined, Search: searchText || undefined }; return this.http.post<{ logs: any[]; totalCount: number }>(`${this.API_URL}/batches/logs`, payload);
  }

  reprocessEmployee(jobGuid: string, employeeId: number, empCode: string = ''): Observable<any> {
    return this.http.post(`${this.API_URL}/reprocess-employee`, this.session.SetClass({
      jobGuid,
      employeeId,
      empCode
    }));
  }

  wakeUpDaemon(): Observable<any> {
    return this.http.post(`${this.API_URL}/resume-batch`, this.session.SetClass({}));
  }

  // private isBrowser(): boolean {
  //   return typeof window !== 'undefined' && typeof localStorage !== 'undefined';
  // }

  // saveActiveJobId(jobId: string): void {
  //   if (this.isBrowser()) localStorage.setItem('', jobId);
  // }

  // getActiveJobId(): string | null {
  //   if (this.isBrowser()) return '';
  //   return null;
  // }

  // clearActiveJobId(): void {
  //   if (this.isBrowser()) localStorage.removeItem(this.STORAGE_JOB_KEY);
  // }
}